import React, { useCallback, useState } from 'react';
import { useTranslation } from "react-i18next";
import TextField from "../../../../components/FormElements/TextField";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import transactionsApi from "../../../../store/transactionsStore/transactionsApi";
import { PhoneInputField } from "../../../../components/PhoneInput";
import styles from './form.module.scss';

const Form = ({
  info,
  phone,
  setPhone,
  setError,
  setUser,
  setCurrentForm,
  certificate,
}) => {
  const { t } = useTranslation();
  const [searching, setSearching] = useState(false);

  const searchingUser = useCallback(() => {
    if (!info || !info.id) return setSearching(false)
    new Promise((resolve, reject) => {
      transactionsApi.getUserInfo('phone', phone.replace(/\D/g, ''), info.id)
        .then((res) => {
          const user = res.data;
          resolve({user});
        })
        .catch((e) => {
          reject(e);
        })
    })
      .then(({user}) => {
        setUser(user);
        setSearching(false);
        setCurrentForm(2);
      })
      .catch(() => {
        setSearching(false);
        setCurrentForm(3);
      });
  }, [phone, info]);

  const onPhoneChange = (value) => {
    setError(false);
    setPhone(value);
  }

  const findUser = (e) => {
    e.preventDefault();

    setSearching(true);
    searchingUser();
  }

  return (
    <form onSubmit={findUser} className={styles.container}>
      <p className={styles.title}>{certificate.header} {certificate.bonus_amount}</p>
      <div style={{ marginBottom: 15, zIndex: 20 }}>
        <PhoneInputField
          placeholder={t('NSAssessment.phone')}
          dropdownStyle={{ borderRadius: 0 }}
          value={phone}
          onChange={onPhoneChange}
          disabled={false}
          error={false}
        />
      </div>

      <ButtonFilled
        type="submit"
        className={styles.btn}
        loading={searching}
        disabled={searching}
      >{t('Certificate.sendCertificate')}</ButtonFilled>
    </form>
  )
}

export default Form